import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"

export const LOCATION_OVERRIDE_INITIALIZED = "LOCATION_OVERRIDE_INITIALIZED"

export const locationOverrideInitialized = (locationId: string) => ({
    type: LOCATION_OVERRIDE_INITIALIZED,
    payload: {
        locationId: locationId,
    },
})

export const LOCATION_OVERRIDE_SELECTED = "LOCATION_OVERRIDE_SELECTED"

export const locationOverrideSelected = (locationId: Maybe<string>) => ({
    type: LOCATION_OVERRIDE_SELECTED,
    payload: {
        locationId: locationId,
    },
})

export const LOCATION_INITIALIZED = "location/initialized"

export const locationInitialized = (locationId: string) => ({
    type: LOCATION_INITIALIZED,
    payload: {
        locationId: locationId,
    },
})

export const LOCATION_SELECTED = "location/selected"

export const locationSelected = (locationId: string) => ({
    type: LOCATION_SELECTED,
    payload: {
        locationId: locationId,
    },
})
